export default __webpack_public_path__ + "static/media/anywhere.7b4e30af.svg";